import { salePaymentApi } from '../../api';
import { PaymentItemDTO } from '../../types/sale/dto/PaymentItemDTO';

const MultiplePaymentService = {

  /**
   * 📊 Obtener pagos + resumen
   * GET /api/sale-payments/{saleId}
   */
  getPaymentsWithSummary: async (saleId: number) => {
    const response = await salePaymentApi.fetchCustom(`/${saleId}`);
    return response.data;
  },

  /**
   * ➕ Agregar pago
   * POST /api/sale-payments/{saleId}
   */
  addPayment: async (saleId: number, dto: PaymentItemDTO) => {
    const response = await salePaymentApi.addCustom(`/${saleId}`, dto);
    return response.data;
  },

  /**
   * ✏️ Actualizar pago
   * PUT /api/sale-payments/{saleId}/{paymentId}
   */
  updatePayment: async (saleId: number, paymentId: number, dto: PaymentItemDTO) => {
    const response = await salePaymentApi.modifyCustom(`/${saleId}/${paymentId}`, dto);
    return response.data;
  },

  /**
   * 🗑️ Eliminar pago
   * DELETE /api/sale-payments/{saleId}/{paymentId}
   */
  deletePayment: async (saleId: number, paymentId: number) => {
    const response = await salePaymentApi.removeCustom(`/${saleId}/${paymentId}`);
    return response.data;
  },

  /**
   * 🗑️ Eliminar todos los pagos de la venta
   * DELETE /api/sale-payments/{saleId}
   */
  deleteAllPayments: async (saleId: number) => {
    const response = await salePaymentApi.removeCustom(`/${saleId}`);
    return response.data;
  },

  /**
   * 📉 SOLO resumen (opcional)
   */
  getMultiplePaymentSummary: async (saleId: number) => {
    const response = await salePaymentApi.fetchCustom(`/${saleId}/summary`);
    return response.data;
  },

  /**
   * 💳 Métodos de pago
   */
  getAvailableMethods: async () => {
    const response = await salePaymentApi.fetchCustom('/methods');
    return response.data;
  },
};

export default MultiplePaymentService;